<template>
  <div class="portal__content claim__message">
    <div class="claim__item claim__item--gradient">
      <form-factory
        formclass="claim__content"
        :record="message"
        :schema="schema"
        :layout="layout"
        :hasError="hasError"
        :submitText="this.getUiString(['claim_details', 'message', 'send_button'])"
        cancelText=""
        @submit="sendMessage"
      >
        <h3
          class="claim__item--title title--l"
        >{{ this.getUiString(['claim_details', 'message', 'title']) }}</h3>
      </form-factory>
      <div class="text" v-if="isSent">{{ this.getUiString(['claim_details', 'message', 'message_sent_text']) }}</div>
      <div v-bind:class="getErrorClass">
        <div class="error" v-if="hasError">{{ this.getUiString(['claim_details', 'message', 'message_send_error']) }}
          <lennoc-expandable-content
            @triggered="$emit('setHeight')"
            v-bind:label="this.getUiString(['claim_details', 'message', 'read_more'])"
            v-if="errorMessageDescription !== ''">
            <div class="text">{{ errorMessageDescription }}</div>
          </lennoc-expandable-content>
          </div>
        </div>
        <lennoc-spinner v-if="busy" isFullscreen="false"></lennoc-spinner>
    </div>
  </div>
</template>

<script>
import LennocInput from '@lennoc/lennoc-components/src/components/LennocInput'
import LennocTextArea from '@lennoc/lennoc-components/src/components/LennocTextArea'
import { mapGetters } from 'vuex'
import { generaltext, novalidator } from '@/validators/index.js'

export default {
  name: 'ClaimBerichtTab',
  data () {
    return {
      busy: false,
      message: {
        subject: '',
        body: ''
      },
      isSent: false,
      hasError: false,
      error: ''
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      currentClaim: 'claim/currentClaim'
    }),
    schema () {
      return {
        subject: {
          key: 'subject',
          required: true,
          label: this.getUiString(['claim_details', 'message', 'subject']),
          type: 'String',
          editor: LennocInput,
          validators: this.genValidators
        },
        body: {
          key: 'body',
          required: true,
          label: this.getUiString(['claim_details', 'message', 'message']),
          type: 'String',
          editor: LennocTextArea,
          validators: this.noValidators
        }
      }
    },
    layout () {
      return ['subject', 'body']
    },
    getErrorClass () {
      return this.hasError ? 'form__group--error' : ''
    },
    genValidators () {
      return [generaltext]
    },
    noValidators () {
      return [novalidator]
    }
  },
  methods: {
    sendMessage (message) {
      this.busy = true
      this.isSent = false
      this.hasError = false
      this.errorMessage = ''
      this.errorMessageDescription = ''
      try {
        const msg = {
          claimId: this.currentClaim.Id,
          subject: message.subject,
          body: message.body
        }
        this.$store
          .dispatch('claim/sendMessage', msg)
          .then(result => {
            this.$store.dispatch('claim/refreshClaim')
            this.busy = false
          })
          .finally(() => {
            this.busy = false
            this.isSent = true
          })
      } catch (error) {
        this.hasError = true
        this.errorMessageDescription = error
        this.busy = false
        throw error
      }
    }
  }
}
</script>
